import React from "react";
import loader from "./loader";

// Single full-width <tr> for a table body: spinner while loading, message when empty.
const TableStatusRow = ({ loading, colSpan, message = "No Data Found" }) => {
  return (
    <tr>
      <td colSpan={colSpan} className="text-center p-5">
        {loading ? loader() : <p className="m-0">{message}</p>}
      </td>
    </tr>
  );
};

export default TableStatusRow;
